import React, { useEffect, useRef, useState } from "react";
import "./CriarOrigemCarregamentoTrilhosReempregoModal.css";

const sanitizeCidadeInput = (value, max = 80) =>
  String(value ?? "")
    .replace(/[\u0000-\u001F\u007F]/g, "")
    .replace(/[<>]/g, "")
    .toUpperCase()
    .slice(0, max);

const sanitizeCidadeSave = (value, max = 80) => sanitizeCidadeInput(value, max).trim();

const sanitizeUf = (value) =>
  String(value ?? "")
    .replace(/[^A-Za-z]/g, "")
    .trim()
    .toUpperCase()
    .slice(0, 2);

export default function CriarOrigemCarregamentoTrilhosReempregoModal({ open, onClose, onSalvar }) {
  const [cidade, setCidade] = useState("");
  const [uf, setUf] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const cidadeRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    setCidade("");
    setUf("");
    setBusy(false);
    setErr("");
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => cidadeRef.current?.focus(), 0);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  async function handleSalvar() {
    if (busy) return;
    setBusy(true);
    setErr("");
    try {
      const cidadeValue = sanitizeCidadeSave(cidade);
      const ufValue = sanitizeUf(uf);
      if (!cidadeValue) throw new Error("Informe a cidade.");
      if (!ufValue || ufValue.length !== 2) throw new Error("Informe a UF com 2 letras.");
      await onSalvar?.({ cidade: cidadeValue, uf: ufValue });
      onClose?.();
    } catch (e) {
      setErr(e?.response?.data?.error || e?.message || "Falha ao salvar.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="ocrcr-overlay" onClick={onClose}>
      <div className="ocrcr-card" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="Cadastrar origem de carregamento reemprego">
        <div className="ocrcr-head">
          <h3 className="ocrcr-title">Cadastrar Origem - Trilhos Reemprego</h3>
          <button className="ocrcr-close" type="button" onClick={onClose} disabled={busy} aria-label="Fechar">
            x
          </button>
        </div>

        <div className="ocrcr-body">
          <label className="ocrcr-field">
            <span>Cidade</span>
            <input
              ref={cidadeRef}
              type="text"
              value={cidade}
              onChange={(e) => setCidade(sanitizeCidadeInput(e.target.value))}
              placeholder="Ex: PARANAGUA"
              autoComplete="off"
            />
          </label>
          <label className="ocrcr-field">
            <span>Estado (UF)</span>
            <input
              type="text"
              value={uf}
              onChange={(e) => setUf(sanitizeUf(e.target.value))}
              placeholder="Ex: PR"
              autoComplete="off"
            />
          </label>
          {err ? <div className="ocrcr-error">{err}</div> : null}
        </div>

        <div className="ocrcr-foot">
          <button className="ocrcr-btn ocrcr-btn-ghost" type="button" onClick={onClose} disabled={busy}>
            Cancelar
          </button>
          <button className="ocrcr-btn ocrcr-btn-primary" type="button" onClick={handleSalvar} disabled={busy}>
            {busy ? "Salvando..." : "Salvar"}
          </button>
        </div>
      </div>
    </div>
  );
}


